import { Get, Post, Put, GetComToken } from './BaseService';
import { API_URL, authHeaders } from '../../config/api';

const urlAreaNaoLogada = `${API_URL}/Usuario`;
const urlAreaLogada = `${API_URL}/Usuario`;

export async function Register (nome, email, senha, cpf, celular, cupom, valor) {
    const endpoint = '/Cadastro?nome='+ nome + '&email=' + email + '&celular=' + celular + '&cpf='+cpf+'&senha='+senha+'&valor='+valor+'&cupom='+cupom;
    const headers = { 
        'Accept': 'application/json',
        "Access-Control-Allow-Headers" : "Content-Type",
        
    };

    return await GetComToken(urlAreaLogada + endpoint, headers);
}

export async function EmailAtivacao (email, nome, senha, tokenValidacao) {
    const endpoint = '/EmailAtivacao?email='+ email + '&nome=' + nome + '&senha=' + senha + '&tokenValidacao=' + tokenValidacao;
    
    const headers = { 
        'Accept': 'application/json',
        "Access-Control-Allow-Headers" : "Content-Type"
    };

    return await Get(urlAreaNaoLogada + endpoint, headers);
}

export async function EnviarEmailSenha (email) {
    const endpoint = '/EnviarEmailSenha?email='+ email;
    const headers = { 
        'Accept': 'application/json',
        "Access-Control-Allow-Headers" : "Content-Type"
    };

    return await Get(urlAreaNaoLogada + endpoint, headers);
}

export async function RequestValidation (request) {
    const endpoint = '/RequestValidation?request='+ request;
    const headers = { 
        'Accept': 'application/json',
        "Access-Control-Allow-Headers" : "Content-Type"
    };
    var data = await Get(urlAreaNaoLogada + endpoint, headers);
    return data;
}


export async function Consult(email, password) {
    return await Post(`${API_URL}/v1/auth/login`, { email, senha: password });
}

export async function getUser (email, senha) {
    const params = new URLSearchParams({
        email,
        data: senha || '',
        _: Date.now().toString()
    });
    const endpoint = '/getUser?' + params.toString();
    const headers = authHeaders();

   return await GetComToken(urlAreaLogada + endpoint, headers);
}

export  async function updateUser(user) {
    return await Put(`${API_URL}/v1/users/me`, {
        nome: user.nome,
        cidade: user.cidade,
        uf: user.uf,
        celular: user.celular,
        ...(user.senha ? { senha: user.senha } : {})
    }, { headers: authHeaders() });
    }
